import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getCMAApiClient } from "../../apis/comps/cma/api-factories";
import { buildGetCmaPresentationEditQueryKey } from "./useGetCmaPresentationEdit";

type Props = {
  onSuccess?: () => void;
  onError?: (error: any, params: Params) => void;
};

type Params = {
  cmaId: string;
  imgId: number;
};

export const useDeleteSubjectPropertyPhoto = (props?: Props) => {
  const { onSuccess, onError } = props || {};
  const api = getCMAApiClient();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const { cmaId, imgId } = params;

      const response = await api.cMAControllerRemoveSubjectPropertyPhoto({
        id: cmaId,
        imgId,
      });

      setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: buildGetCmaPresentationEditQueryKey(cmaId),
        });
      }, 1500);

      onSuccess?.();
      return response;
    },
    onError: async (error, params) => {
      console.error(
        `Failed to delete CMA (${params.cmaId}) photo with id ${params.imgId}`,
        error,
      );
      queryClient.invalidateQueries({
        queryKey: buildGetCmaPresentationEditQueryKey(params.cmaId),
      });
      onError?.(error, params);
    },
  });

  return mutation;
};
